<template>
  <div class="wrapper">
    <div class="tabs">
      <div
        class="tab"
        v-for="(item,index) in tabs"
        :key="index"
        :class="{'active':activeIndex==item.type}"
        @click="showList(item)"
      >{{item.title}}</div>
    </div>
    <div class="coupon-list">
      <div class="coupon-wrap" v-for="(item,index) in couponList"
        :key="index"
        :class="{'nouse':item.is_used!=1}" >
        <div class="content">
          <div class="price">
            <span class="num">{{item.name}}</span>
          </div>
          <div class="desc">{{item.expression1}}&nbsp;&nbsp;{{item.expression2}}</div>
          <div class="time">{{item.stime}}&nbsp;--&nbsp;{{item.etime}}</div>
        </div>
        <div class="status">
          <template v-if="item.is_used==2">
            <i class="icon iconfont iconused"></i>
          </template>
          <template v-else-if="item.is_expire==2">
            <i class="icon iconfont iconnouse"></i>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, hideLoading } from '../../utils/loading'
export default {
  name: "Coupon",
  components: {},
  props: {},
  data() {
    return {
      tabs: [
        {
          type: 0,
          title: "未使用",
          display:"no_used"
        },
        {
          type: 1,
          title: "已使用",
          display:'yes_used'
        },
        {
          type: 2,
          title: "已失效",
          display:"invalid"
        }
      ],
      activeIndex: 0,
      couponList: [],
      display:"no_used"
    };
  },
  watch: {},
  computed: {},
  methods: {
    showList(item) {
	  showLoading();
      this.activeIndex = item.type;
      this.display=item.display;
      this.getUserCoupon()
    },
    getUserCoupon() {
      let data={
        display:this.display
      }
      this.$api.userCoupon(data).then(res => {
        if (res.status) {
          this.couponList = res.data.list;
        }
		hideLoading();
      });
    }
  },
  created() {},
  mounted() {
	  showLoading();
    this.getUserCoupon();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.coupon-wrap{
  width: 280px;
  margin:0 20px 20px 0;
}
.tabs {
  display: flex;
  border-bottom: 1px solid $border;
  padding: 20px 0;
  margin-bottom: 20px;
  .tab {
    padding: 0 20px;
    color: #757575;
    cursor: pointer;
    &:hover {
      color: #333;
    }
    &.active {
      color: $theme-color;
    }
    &:not(:last-of-type) {
      border-right: 1px solid $border;
    }
  }
}
</style>